import { useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { MOO_V2_OPEN_CONVERSATION_EVENT } from '../v2/AskMooIntegrationV2';
import { openNudge } from './nudgeActions';
import type { Nudge } from './nudgeStore';

/**
 * Returns a handler that opens a nudge's conversation in the Moo chat panel,
 * closes its snackbar, and marks it read/removed. Used by clicking a nudge card
 * and by its popout icon.
 */
export function useNudgeOpen(): (nudge: Nudge) => void {
  const { closeSnackbar } = useSnackbar();

  return useCallback(
    (nudge: Nudge) => {
      window.dispatchEvent(
        new CustomEvent(MOO_V2_OPEN_CONVERSATION_EVENT, {
          detail: {
            conversationId: nudge.conversationId,
            agentId: nudge.agentId,
          },
        })
      );
      closeSnackbar(nudge.id);
      openNudge(nudge.id);
    },
    [closeSnackbar]
  );
}
